import type { BaseRouteType, BaseMethodType } from '../types.ts'
import { z } from "zod";
export const tagsPatchMunicipalities_municipalityIdSubscriptions_idPay = z.any()
export type TagsPatchMunicipalities_municipalityIdSubscriptions_idPay = z.infer<typeof tagsPatchMunicipalities_municipalityIdSubscriptions_idPay>

export const paramsPatchMunicipalities_municipalityIdSubscriptions_idPay = z.object({ "municipalityId": z.string().uuid(), "id": z.string().uuid() })
export type ParamsPatchMunicipalities_municipalityIdSubscriptions_idPay = z.infer<typeof paramsPatchMunicipalities_municipalityIdSubscriptions_idPay>

export const responsePatchMunicipalities_municipalityIdSubscriptions_idPay = z.object({ "payload": z.object({ "code": z.union([z.string(), z.number()]), "message": z.string(), "transId": z.string(), "redirect": z.string() }).optional(), "errors": z.any(), "message": z.string().optional() })
export type ResponsePatchMunicipalities_municipalityIdSubscriptions_idPay = z.infer<typeof responsePatchMunicipalities_municipalityIdSubscriptions_idPay>

interface IPatchMunicipalities_municipalityIdSubscriptions_idPay extends BaseMethodType {
  tags: TagsPatchMunicipalities_municipalityIdSubscriptions_idPay,
  params: ParamsPatchMunicipalities_municipalityIdSubscriptions_idPay,
  response: ResponsePatchMunicipalities_municipalityIdSubscriptions_idPay
}
export const URL = '/municipalities/:municipalityId/subscriptions/:id/pay'
export const validation = {
  patch: {
    tags: tagsPatchMunicipalities_municipalityIdSubscriptions_idPay,
    params: paramsPatchMunicipalities_municipalityIdSubscriptions_idPay,
    response: responsePatchMunicipalities_municipalityIdSubscriptions_idPay
  }
}
export interface Municipalities_municipalityIdSubscriptions_idPay extends BaseRouteType {
  patch: IPatchMunicipalities_municipalityIdSubscriptions_idPay
}